/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для списка стран.
   */
  app.ChoiceCountryPopupView = app.View.extend({
    
    events: {
      'click .country': 'choiceCountry'
    },
    
    /**
     * Выбор страны
     * @param {object} e Event
     */
    choiceCountry: function (e) {
      /**
       * Английское наименование страны
       */
      var countryNameEn = $(e.currentTarget).data('country');
      /**
       * Данные по флагу
       */
      var countryFlag = app.countryFlags[countryNameEn];
      this.model.set({
        nameEn: countryNameEn,
        nameRu: countryFlag.nameRu,
        code: countryFlag.code,
        countryId: countryFlag.countryId
      });
      if (this.model.get('id') === 1) {
        this.model.save();
      }
      e.stopPropagation();
    }
  });
})(jQuery);

}.call(window));